import React, {useMemo, useState,useEffect} from 'react'
import Namespace from 'src/constants/locale/Namespace'
import AceOcnPermitToTransferKeys from 'src/constants/locale/key/AceOcnPermitToTransfer'
import { Grid, Card, CardContent } from '@material-ui/core'
import {
  components,
  DataFlattener,
  DateTimeFormatter,
} from 'cng-web-lib'
import makeValidationSchema from './MakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import BillOfLadingPTTSection from './BillOfLadingPTTSection'
import { useFormContext,useWatch } from "react-hook-form";
import { NaUSPortAutocompleteField } from 'src/components/na'
import { FileForUserGetUserDetails,FileForUserGetPartyId } from 'src/common/FileForUserCommon'

const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngTextField,
      CngDateField,
      CngCodeMasterAutocompleteField,
      CngCountryAutocompleteField
    },
  },
  table: {
    CngLocalModeDialogFormTable,
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  manifestHeaderId: null,
  scac: "",
  vesselName: "",
  voyageNumber: "",
  country: "",
  portOfDischarge: "",
  eta: "",
  modeOfTransport: "",
  paperlessInBondParticipant: "",
  issuerScac: "",
  billOfLading: [],
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled: disabledFromProps, showNotification, shouldHideMap , isEditMode }) {
  const { translate } = useTranslation(Namespace.ACE_OCN_PERMIT_TO_TRANSFER)
  const translatedTextsObject = makeTranslatedTextsObject()
  const {watch, setValue} = useFormContext()
  const manifestHeaderId = watch('manifestHeaderId')
  const disabled = isEditMode ? false : !!manifestHeaderId || disabledFromProps

  function makeTranslatedTextsObject() {
    let aceOcnPTTManifestHeaderDTO = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.TITLE
    )
    let scac = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.SCAC
    )
    let vesselName = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.VESSEL_NAME
    )
    let voyageNumber = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.VOYAGE_NUMBER
    )
    let country = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.COUNTRY
    )
    let portOfDischarge = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.PORT_OF_DISCHARGE
    )
    let eta = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.ETA
    )
    let modeOfTransport = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.MODE_OF_TRANSPORT
    )
    let paperlessInBondParticipant = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.PAPERLESS_IN_BOND_PARTICIPANT
    )
    let issuerScac = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.ISSUER_SCAC
    )
    let billOfLading = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.TITLE
    )
    let billNumber = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.BILL_OF_LADING_NUMBER
    )
    let firmsCode = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.FIRMS_CODE
    )
    let bondedCarrierType = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.BONDED_CARRIER_TYPE
    )
    let bondedCarrier = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.BONDED_CARRIER
    )
    let containerNumber = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.CONTAINER_NUMBER
    )
    let quantity = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.QUANTITY
    )
    let remarks = translate(
      Namespace.ACE_OCN_PERMIT_TO_TRANSFER,
      AceOcnPermitToTransferKeys.BillOfLading.REMARKS
    )

    return {
      aceOcnPTTManifestHeaderDTO,
      scac,
      vesselName,
      voyageNumber,
      country,
      portOfDischarge,
      eta,
      modeOfTransport,
      paperlessInBondParticipant,
      issuerScac,
      billOfLading,
      billNumber,
      firmsCode,
      bondedCarrierType,
      bondedCarrier,
      containerNumber,
      quantity,
      remarks,
    }
  }

  const billOfLading = watch('billOfLading')
  const [billOfLadingDirty, setBillOfLadingDirty] = useState(false)

  useWatch({ name: "fileForUserId" })
  useWatch({ name: "fileForUserLoginId" })
  useWatch({ name: "fileForUserPartyId" })
  useEffect(() => {
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      setValue("fileForUserId", fileForUserDetails.fileForUserId)
      setValue("fileForUserLoginId", fileForUserDetails.fileForUserLoginId)
      setValue("fileForUserPartyId", fileForUserDetails.fileForUserPartyId)
    }
  }, []);
  const memoedBillOfLadingPTTSection = useMemo(
    () => <BillOfLadingPTTSection 
    billOfLading={billOfLading} 
    setBillOfLadingDirty={setBillOfLadingDirty} 
    />,
    [billOfLading]
  )

	return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CngSimpleCardHeader title={translatedTextsObject.aceOcnPTTManifestHeaderDTO} />
          <CardContent>
            <Grid container spacing={3}>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.scac}>
                <CngTextField
                  name="scac"
                  label={translatedTextsObject.scac}
                  disabled={disabled}
                  size='small'
                  required
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.vesselName}>
                <CngTextField
                  name="vesselName"
                  label={translatedTextsObject.vesselName}
                  disabled={disabled}
                  size='small'
                  required
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.voyageNumber}>
                <CngTextField
                  name="voyageNumber"
                  label={translatedTextsObject.voyageNumber}
                  disabled={disabled}
                  size='small'
                  required
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.country}>
                <CngCountryAutocompleteField
                  name="country"
                  label={translatedTextsObject.country}
                  disabled={disabled}
                  lookupProps={{
                    label: (record) => {
                      return `${record.code};${record.descriptionEn}`
                    }
                  }}
                  size='small'
                  required
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.portOfDischarge}>
                <NaUSPortAutocompleteField
                  name="portOfDischarge"
                  label={translatedTextsObject.portOfDischarge}
                  disabled={disabled}
                  size='small'
                  required
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.eta}>
                <CngDateField
                  name="eta"
                  label={translatedTextsObject.eta}
                  disabled={disabled}
                  size='small'
                  required
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.modeOfTransport}>
                <CngCodeMasterAutocompleteField
                  name="modeOfTransport"
                  label={translatedTextsObject.modeOfTransport}
                  disabled={disabled}
                  codeType='ACEOCN_MANI_MOT'
                  size='small'
                  required
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.paperlessInBondParticipant}>
                <CngCodeMasterAutocompleteField
                  name="paperlessInBondParticipant"
                  size='small'
                  label={translatedTextsObject.paperlessInBondParticipant}
                  disabled={disabled}
                  codeType='Y_OR_N'
                  required
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.issuerScac}>
                <CngTextField
                  name="issuerScac"
                  label={translatedTextsObject.issuerScac}
                  disabled={disabled}
                  size='small'
                  required
                />
              </CngGridItem>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        {memoedBillOfLadingPTTSection}
      </Grid>
    </Grid>
	)
}

function toClientDataFormat(serverData) {
  let localData = DataFlattener.parse(serverData);
  localData.eta = DateTimeFormatter.toClientDate(
    localData.eta
  );
  return localData;
}

function toServerDataFormat(localData) {
  localData.eta = DateTimeFormatter.toServerDate(
    localData.eta
  );
  return DataFlattener.unflatten(localData);
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default FormProperties
